import { NUMBER_FORMATTER } from '@agilox/common';
import { Provider } from '@angular/core';
import { CustomNumberPipe } from './custom-number.pipe';

export function provideNumberFormatter(): Provider[] {
	return [{ provide: NUMBER_FORMATTER, useExisting: CustomNumberPipe }];
}
